<div class="info">
	<ng-content select="strong" />
	<ng-content select="span" />
</div>

<ng-content select=".actions" />
